// extracted by mini-css-extract-plugin
module.exports = {"Warning":"SourceOutline_Warning__0HcJ4"};